import React from "react";
import { IoIosArrowRoundForward } from "react-icons/io";

export default function HowToRequest() {
  return (
    <div id="howToRequest">
      <div className="left">
        <div className="header">
          <p className="call">Call 24/7 hotline 8180 8948 or use Speedoc’s app</p>
          <h2>How to request Speedoc to you</h2>
        </div>
        <p>
          <strong>Provide details</strong>
          <br />
          Reason for medical assistance, for whom and location.
        </p>
        <p>
          <strong>Transparent</strong>
          <br />
          Review consultation pricing before confirmation of booking.
        </p>
        <p>
          <strong>Fast</strong> <br />
          Wait for our doctor to arrive at your location. <br />
          <span className="lighter">(Waiting time is between 1 to 2 hours)</span>
        </p>
        <p>
          <strong>Reliable</strong> <br />
          Similar to a visit to the GP clinic, our doctor will ask questions, run tests and diagnose your condition
          based on your signs and symptoms.
        </p>
        <p>
          <strong>MOH Regulatory Sandbox</strong>
          <br /> Medical certificates (MCs) will be provided as necessary.
        </p>
        <p>
          <strong>Efficient</strong>
          <br /> Medications can be provided on the spot or arranged for delivery subsequently.
        </p>
        <button className="primary" aria-label="learn more button">
          <a href="/">
            <span>Learn More</span>
            <IoIosArrowRoundForward />
          </a>
        </button>
      </div>
      <div className="right">
        <img alt="hero features" src="//public.speedoc.com/design/images/speedoc.com/img/Hero-image-features.jpg" />
      </div>
    </div>
  );
}
